import { reactive } from 'vue'

export const store = reactive(
    {
        specialPrice: {
            byImprintMethods: {},// {isImprintMethodSpecial: false, }
            isProductSpecial: false,
            value: null,
            dateStart: null,
            dateEnd: null,
            tier: []
        },
        imprintStep: {
            applyToAll: {
                id: null,
                selectedColor: null,
                index: null,
                randID: null
            },
        },
        isCustomerGuest: false,
        calendar: {
            productPageTitle: "",
            productImage: "",
            productList: [],
            IsCalendar: {
                title: 'Is Calendar',
                value: 'Yes'
            },
            qtyVal: 25
        },
        isCustomBundlePage: false,
        storeID: 'mlp_us',
        sizesQty: {},
        application_type: 'default', // 'calendar'|'calendar_single'
        lastMaxInitedStep: 1,
        // !!!! output selected by user data
        // slectedColor currently 31.05.2023 used from colorSizeLines[]
        slectedColor: {
            id: null,
            title: '',
            img_src: ''
        },
        // TODO improve
        upchargesLines: {},
        /* TODO logic changed check to remove both variable - Should be used only one variable selectedColorsList or availableColorsList*/
        selectedColorsList: [],
        availableColorsList: [],
        hasFullSizeNames: false,
        fullSizeNameToShort: {},
        colorSizeLines:[],

        selectedLastStep: {},

        imprintMessageColorLines: [],
        totalSizesQty: {},
        mainVariantId: '', // 31.05.2023 currently not seted
        selectedImprint: {
            id: null,
            tabName: '',
            sku: null,
            data: null
        },
        prices: {
            // set after change imprint tab
            tier: null,
            tierMSRP: null,
            // set if change qty, and in imprintAppSummary as we need update if imprint tab changed
            priceByQty: null,
            // if size has the upcharge prise
            priceSizeUpcharge: 0,
            priceColorUpcharge: 0,

            setup_fee: 0, // implement prices.setup_fee instead setupFee
            proof_fee: 0,
            image_fee: 0,
            customColourFee: 0,
            running_fee: 0
        },

        setupFee: 0,
        customColourFee: {},

        perItemFee: {
            setupFee: 0,
            customColourFee: 0,
            proof_fee: 0,
            running_fee: 0,
            image_fee: 0,
        },

        // TODO can be added also imprint sku and removed from before data
        sku: {
            fee: {
                setup_fee: {
                    title: '',
                    val: null
                },
                custom_colour_fee: {
                    title: '',
                    val: null
                },
                proof_fee:  {
                    title: '',
                    val: null
                },
                running_fee:  {
                    title: '',
                    val: null
                },
                image_fee:  {
                    title: '',
                    val: null
                },
            },
            imprint: {
                method:  {
                    title: '',
                    val: null
                },
                location:  {
                    title: '',
                    val: null
                },
                line_colors: []
            },
            color_code: false
        },
        properties: {
            product_weight: {
                title: 'Product Weight',
                val: null
            },
        },

        // will be used in future, for save user information, for every imprint tabs
        historyByImprint:[
            {
                // check and rename sky to sku
                sky: null,
                totalQty: null
            }
        ],

        // !!!! input income data
        productType: '',
        inputProuctIds: {
            mainProductID: '',
        },
        inputProductData: {
            fullJson: null,
            colorVariants: {
                handle: null,
                data: null
            },
            sizeVariants: {
                handle: null,
                data: null
            },
            sizeUpcharge: {},
            colorUpcharge: {},
            imprintVariants: {
                handle: null,
                data: null
            },
            /* by default 1, seted after done init*/
            qtyIncrement: null,
            minOrderQty: null,
            associatedIds: null,
        },
        disabledAddToCart : false,
        qtyError: null,
        imprintKey: null
    }
)